import script from "./HeaderWebComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWebComponents.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWebComponents.vue?vue&type=style&index=0&id=468ba86c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468ba86c"]])

export default __exports__